export default function getSelectedTrails(state) {
  return state.trails.selected;
}
